export default __webpack_public_path__ + "static/media/lista_submin_gas.69c5c980.svg";